/* =========================
   FADE-IN ON SCROLL
========================= */

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".shopify-section");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in-visible");
        }
      });
    },
    {
      threshold: 0.15,
    }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });
});